import 'regenerator-runtime';
import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
// import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
} from '../actions';
import { convertObjectToQueryParams } from 'src/utils/util';

const getParams = ({ products, orderType, sapPartnerId }) => {
    const salesOrgList = [];
    products &&
        products.forEach((product) => {
            product.productCFN
                ? salesOrgList.push(product.productCFN)
                : salesOrgList.push(product.cfn);
        });
    return convertObjectToQueryParams({
        productCFN: salesOrgList.join(),
        sapPartnerId,
        orderType,
    });
};

export default function* getPricesForConsignmentItemsSaga(action) {
    const productCFN = encodeURIComponent(action.payload ? action.payload.productCFN : '');
    const sapPartnerId = encodeURIComponent(action.payload ? action.payload.sapPartnerId : '');
    const orderType = encodeURIComponent(action.payload ? action.payload.orderType : '');
    const territoryId = encodeURIComponent(action.payload ? action.payload.territoryId : '');
    const isBKPProductsDisplay = encodeURIComponent(action.payload
        ? action.payload.isBKPProductsDisplay
        : false);
    const districtId = encodeURIComponent(action.payload ? action.payload.districtId : '');
    const billToId = encodeURIComponent(action.payload?.billToId ? action.payload.billToId : '');
    try {
        const result = yield axios({
            method: 'get',
            url: `occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/order/usage/price?productCFN=${productCFN}&sapPartnerId=${sapPartnerId}&orderType=${orderType}&territoryId=${territoryId}&isBKPProductsDisplay=${isBKPProductsDisplay}&districtId=${districtId}&billToId=${billToId}`,
        }).then((response) => response.data);
        // const result = testRes;
        yield put({
            type: GET_PRICES_FOR_ITEMS_SUCCESS,
            payload: {
                items: result.priceDetails,
                isPricingDone: true,
            },
        });
    } catch (e) {
        const url = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/order/usage/price?productCFN=${productCFN}&sapPartnerId=${sapPartnerId}&orderType=${orderType}&territoryId=${territoryId}&isBKPProductsDisplay=${isBKPProductsDisplay}&districtId=${districtId}&billToId=${billToId}`;
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRICES_FOR_ITEMS_FAILURE,
            payload: { items: [], isPricingDone: false },
        });
    }
}
